import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import ticketStore from './ticketStore.js'
import siteStore from './siteStore.js'
import ZoneStore from './ZoneStore.js'
import categoryStore from './categoryStore.js'
import dialogStore from './dialogStore.js'
import loadStore from './loadStore.js'
// Vue.use(Vuex)
export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    ticketStore,
    // companyStore,
    // actionStore,
    // previewStore,
    siteStore,
    ZoneStore,
    categoryStore,
    dialogStore,
    loadStore
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js